import { render } from "./component-renderer.vue?vue&type=template&id=11820f99"
import script from "./component-renderer.vue?vue&type=script&lang=js"
export * from "./component-renderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__